export function partnerProfileGet(pic, callback) {
	return {
    type: 'PARTNER_PROFILE_GET',
    payload: {
			pic: pic,
		},
		callback: callback
	}
}


export function partnerPostGet(pic, page, callback) {
	return {
    type: 'PARTNER_POST_LIST_GET',
    payload: {
			pic: pic,
      page: page,
		},
		callback: callback
	}
}

export function partnerPostGoodEdit(pic, postId, callback) {
	return {
		type: "PARTNER_POST_GOOD_EDIT",
		payload: {
			pic: pic,
			postId: postId,
		},
		callback: callback
	}
}


export function partnerQaQuestionListGet(pic, callback) {
	return {
    type: 'PARTNER_QA_QUESTION_LIST_GET',
    payload: {
			pic: pic,
		},
		callback: callback
	}
}

export function partnerQaQuestionAnswerAdd(qaId, answerOpen, answerText, callback) {
	return {
		type: "PARTNER_QA_QUESTION_ANSWER_ADD",
		payload: {
			qaId: qaId,
			answerOpen: answerOpen,
			answerText: answerText,
		},
		callback: callback
	}
}

export function partnerQaQuestionAnswerDel(qaId, callback) {
	return {
		type: "PARTNER_QA_QUESTION_ANSWER_DEL",
		payload: {
			qaId: qaId,
		},
		callback: callback
	}
}

export function partnerQaAnswerListGet(pic, page, callback) {
	return {
    type: 'PARTNER_QA_ANSWER_LIST_GET',
    payload: {
			pic: pic,
      page: page,
		},
		callback: callback
	}
}
